import styled from 'styled-components';
import breakpoint from '~/utils/style-utils';

export const GridsContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: flex-start;
`;

export const Grid = styled.div<{
	widthMobile: string;
	widthDesktop: string;
	heightMobile: string;
	heightDesktop: string;
	extraStyles?: Record<string, string>;
	extraStylesMobile?: Record<string, string>;
	extraStylesDesktop?: Record<string, string>;
}>`
	display: grid;
	gap: 12px;
	margin-right: 12px;
	width: ${({ widthMobile }) => widthMobile};
	height: ${({ heightMobile }) => heightMobile};
	${({ extraStyles }) => extraStyles}
	${({ extraStylesMobile }) => extraStylesMobile}
	&:last-of-type {
		margin-right: unset;
	}

	${({ widthDesktop, heightDesktop, extraStylesDesktop }) => breakpoint.lg`
		width: ${widthDesktop};
		height: ${heightDesktop};
		${extraStylesDesktop}
	`}
`;

export const CardContainer = styled.div<{
	size: { widthMobile: string; widthDesktop: string; heightMobile: string; heightDesktop: string };
	position?: string | false;
}>`
	display: flex;
	justify-content: center;
	align-items: center;
	width: ${({ size }) => size.widthMobile};
	height: ${({ size }) => size.heightMobile};

	${({ position }) => position};

	${({ size }) => breakpoint.lg`
		width: ${size.widthDesktop};
		height: ${size.heightDesktop};
	`}
`;
